import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { WidgetBoxComponent } from '../../widgets/box/box.component';
import { WidgetButtonComponent } from '../../widgets/button/button.component';
import { StateHelper } from '../../helpers/state.helper';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  imports: [
    WidgetBoxComponent,
    WidgetButtonComponent,
  ]
})
export class AppHomeComponent implements OnInit {

  /**
   * State helper
   */
  state_helper = inject(StateHelper);

  /**
   * List of games
   */
  games = signal([
    {
      id: 'games/tidal',
      name: 'Tidal Trader',
      description: 'Challenge your financial management skills.',
      icon: 'fa-solid fa-gauge',
      color: 'pink',
      action: 'Play Game'
    },
    {
      id: 'games/metal',
      name: 'Metal Master',
      description: 'Become a master by winning and holding strong.',
      icon: 'fa-solid fa-flag-checkered',
      color: 'emerald',
      action: 'Play Game'
    }
  ]);

  /**
   * List of tools
   */
  tools = signal([
    {
      id: 'tools/cycle',
      name: 'Staking Rewards',
      description: 'Stake tokens and receive rewards every day.',
      icon: 'fa-solid fa-gift',
      color: 'cyan',
      action: 'View Rewards'
    }
  ]);

  /**
   * List of features
   */
  features = signal([
    {
      caption: 'Multiple Games',
      description: 'A growing collection of unique, connected games built under one unified system.',
      icon: 'fa-solid fa-cubes',
      color: 'purple'
    },
    {
      caption: 'Blockchain Native',
      description: 'All gameplay and features run entirely on-chain, with no off-chain dependencies.',
      icon: 'fa-solid fa-globe',
      color: 'yellow'
    },
    {
      caption: 'Interesting Tokenomics',
      description: 'Platform has a single token, mined and earned exclusively through gameplay.',
      icon: 'fa-solid fa-atom',
      color: 'emerald'
    },
    {
      caption: 'Staking Rewards',
      description: 'A share of daily game volume is distributed to token holders as ongoing player rewards.',
      icon: 'fa-solid fa-gift',
      color: 'cyan'
    },
    {
      caption: 'Deflationary Mechanics',
      description: 'Built-in features help regulate token supply and reduce inflation across the system.',
      icon: 'fa-solid fa-circle-down',
      color: 'pink'
    },
  ]);

  /**
   * Construct component
   */
  constructor(
    private router: Router
  ) { }

  /**
   * Initialize component
   */
  ngOnInit() {
    this.state_helper.setTitle('Kyovy');
    this.state_helper.setPage('');
  }

  /**
   * Navigate to page
   * 
   * @param page
   */
  navigateToPage(page: string) {
    this.router.navigateByUrl(page);
  }
}
